module.exports = __webpack_public_path__ + "media/images/more-icon-2abdb668ba311c789b56dbf70b6da9386e4d9159dad16829878d655003f11fa9.svg";